import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SearchService } from './search.service';
import { filterApplied, FilterResponse } from '../interfaces/interface';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor(private http: HttpClient, private _search: SearchService) {}

  filterApplied: filterApplied[] = [];
  filterAppliedSelected: filterApplied[] = [];
  filterList: FilterResponse[] = [];
  filterSelected: FilterResponse[] = [];
  isShowAdvanceFilter: boolean = false;
  applyFilterSubject = new Subject<any>();
  userListSaved: any[] = [];
  selectedSavedSearchOption: string = 'Saved by me';
  activeAdvanceFilterIndex: number = 0;

  fetchFilters = () => {
    this.getFiltersMe().subscribe({
      next: (res: any) => {
        this.addFilterListWithPosition(res);
      },
    });
  };

  saveFilterPositionToLocalStorage = (filterList: any) => {
    let filterWithPosition: any = {};
    filterList.forEach((filter: any, index: number) => {
      filterWithPosition[filter.name] = index;
    });
    localStorage.setItem(
      'filterListPosition',
      JSON.stringify(filterWithPosition)
    );
  };

  getFilterPositionFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem('filterListPosition') || '[]');
  };

  addFilterListWithPosition = (filterList: any[]) => {
    let saveFilterList: any = this.getFilterPositionFromLocalStorage();
    this.filterList = filterList.sort((a: any, b: any) => {
      return saveFilterList[a.name] - saveFilterList[b.name];
    });
  };

  getFilters = (params: any): Observable<any> => {
    return this.http.get('/api/filters', { params });
  };

  getFiltersMe = (params: any = {}): Observable<any> => {
    return this.http.get('/api/filters/me', { params });
  };

  applyFilters = async (filters: any) => {
    this.filterAppliedSelected = await [...filters];
    this.filterSelected = [];

    await this.filterAppliedSelected.forEach((filter: any) => {
      let selectedFilter : any = this.filterList.find(
        (item: any) => item.name === filter.name
      );
      selectedFilter = { ...selectedFilter };
      selectedFilter.uniqueId = this.generateUniqueId();

      if (selectedFilter) {
        this.filterSelected.push(selectedFilter);
      }
    });
    this._search.applyGetDocument.next(true);
    this.isShowAdvanceFilter = false;
  };

  selectFilters = async (filters: any) => {
    this.filterAppliedSelected = await [...filters];
    this.filterSelected = [];

    await this.filterAppliedSelected.forEach((filter: any) => {
      let selectedFilter :any  = this.filterList.find(
        (item: any) => item.name === filter.name
      );
      selectedFilter = { ...selectedFilter };
      selectedFilter.uniqueId = this.generateUniqueId();
      if (selectedFilter) {
        this.filterSelected.push(selectedFilter);
      }
    });
    this.filterApplied = await [...this.filterAppliedSelected];
  };

  applyFilterAndSelectFirst = async (filters: any) => {
    while (this.filterList.length === 0) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    this.filterAppliedSelected = await [...filters];
    this.filterSelected = [];

    await this.filterAppliedSelected.forEach((filter: any) => {
      let selectedFilter: any = this.filterList.find(
        (item: any) => item.name === filter.name
      );
      selectedFilter = { ...selectedFilter };
      selectedFilter.uniqueId = this.generateUniqueId();
      if (selectedFilter) {
        this.filterSelected.push(selectedFilter);
      }
    });

    await this._search.applyGetDocument.next('selectFirst');
    this.isShowAdvanceFilter = false;
  };

  clearAllFilters = () => {
    this.filterAppliedSelected = [];
    this.filterSelected = [];
  };

  clearAllFiltersAndApply = (isForceApply: boolean = false) => {
    if (this.filterApplied.length <= 0 && !isForceApply) {
      return;
    }
    this.filterAppliedSelected = [];
    this.filterSelected = [];
    this.filterApplied = [];
    this._search.applyGetDocument.next(true);
    this.isShowAdvanceFilter = false;
  };

  initializeFilters = async () => {
    this.filterSelected = [];
    this.filterAppliedSelected = [];
    this.filterAppliedSelected = await [...this.filterApplied];
    await this.filterAppliedSelected.forEach((filter: any) => {
      let selectedFilter :any = this.filterList.find(
        (item: any) => item.name === filter.name
      );
      selectedFilter = { ...selectedFilter };
      selectedFilter.uniqueId = this.generateUniqueId();
      if (selectedFilter) {
        this.filterSelected.push(selectedFilter);
      }
    });
  };

  getOption = (url: string, params: any): Observable<any> => {
    return this.http.get(`${url}`, { params });
  };

  displayKeyMapping: any = {
    lte: 'On or before',
    gte: 'On or after',
    lt: 'Before',
    gt: 'After',
    exact: 'Exact',
    contains: 'Contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',
    must: 'Must',
    must_not: 'Must not',
    should: 'Should',
    exists: 'Exists',
    bool: 'Bool',
    multi_match: 'Multi match',
    prefix: 'Prefix',
    asc: 'Ascending',
    desc: 'Descending',
    range: 'Range',
  };

  generateUniqueId() {
    return Math.random().toString(36).substring(2) + (new Date()).getTime().toString
  }
}
